module.exports = __webpack_public_path__ + "static/media/incorrect_otm_sample_image.c882d473.svg";